import {AsyncPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, output} from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import {select} from '@ngrx/store';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {User} from 'src/app/core/model/user';
import {selectActiveUser} from 'src/app/core/store/active-user/active-user.selector';
import {selectRouterUrl} from 'src/app/core/store/router/router.selector';
import {NavbarItemComponent} from '../navbar-item/navbar-item.component';

@Component({
  selector: 'navbar-user',
  standalone: true,
  imports: [AsyncPipe, MatMenuModule, NavbarItemComponent],
  templateUrl: './navbar-user.component.html',
  styleUrl: './navbar-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarUserComponent {
  private store$ = inject(Store);
  userClick = output<void>();
  activeUser$: Observable<User> = this.store$.pipe(select(selectActiveUser));
  routerUrl$: Observable<string> = this.store$.pipe(select(selectRouterUrl));
  profileUrl = '/profile';
}
